import type { Reactive } from "vue"
import { computed, reactive } from "vue"

const excludedKeys = ["page", "perPage"]

export function useFilters<T extends object>(defaultValues: T) {
  const filters = reactive<T>(defaultValues)

  const update = (values: T) => {
    Object.assign(filters, values)
  }

  const count = computed<number>(() => {
    const appliedFiltersCount = Object.keys(filters).reduce((acc, current) => {
      if (excludedKeys.includes(current)) {
        return acc
      }

      const value = filters[current as keyof Reactive<T>]

      if (Array.isArray(value) && !value.length) {
        return acc
      }

      if (value) {
        return acc + 1
      }

      return acc
    }, 0)

    return appliedFiltersCount
  })

  return {
    filters,
    update,
    count,
  }
}
